import ChatIcon from './ChatIcon';
import CloseIcon from './CloseIcon';
import SubmitIcon from './SubmitIcon';
import MicIcon from './MicIcon';

export { ChatIcon, CloseIcon, SubmitIcon, MicIcon };
